import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function requiredLeafPaths(fields: SchemaField[], prefix: string[] = []): string[] {
  return fields.flatMap((field) => {
    if (field.hidden) return []

    const path = [...prefix, field.name]

    if ((field.type === 'group' || field.type === 'section') && field.fields?.length) {
      return requiredLeafPaths(field.fields, path)
    }

    if (field.required) return [path.join('.')]

    return []
  })
}
